<template>
  <div class="ocrFail">
    <img class="example-img" src="../images/businessCard-example.png" alt="">
    <div class="title">未能识别到名片信息</div>
    <div class="desc">请将名片横向放置在屏幕中间<br />并确保四边角水平进行拍摄</div>

    <cameraBtn @click.native="$emit('cameraBtnClick')"
               style="margin-top: 30px"
               :btnText="cameraBtnText"
               :w="businessCardWidth">
    </cameraBtn>
  </div>
</template>

<script>
import cameraBtn from './cameraBtn'
export default {
  components: { cameraBtn },
  name: 'ocrFail',
  data () {
    return {
      cameraBtnText: '再拍一次名片',
      businessCardWidth: 200
    }
  }
}
</script>

<style scoped lang="less">
@import "../less/variable";
.ocrFail {
  position: relative;
  .w(330);
  background-color: #fff;
  .padding(20, 10);
  .pb(40);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
  .example-img {
    width: 60%;
  }
  .title {
    .fs(18);
    margin-top: 20px;
  }
  .desc {
    .fs(14);
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ocrFail.vue